// 1. Setup enums for Article
import { articleParamKey } from '@/composables/route'

export enum ArticleRouteName {
    Index = 'articles.index',
    Create = 'articles.create',
    Edit = 'articles.edit',
    Show = 'articles.show',
    TempIndex = 'articles.templates.index',
    TempCreate = 'articles.templates.create',
    TempEdit = 'articles.templates.edit',
}

// 2. Set routes
export default {
    path: '/articles',
    component: () => import('@/views/Index.vue'),
    name: 'articles',
    meta: {
        label: 'Articles',
        icon: 'fal fa-clipboard-list fa-fw',
        location: 'sidebar-top',
        permission: 'manage-articles',
        auth: true,
    },
    children: [
        {
            path: '',
            name: ArticleRouteName.Index,
            component: () => import('@/views/article/Index.vue'),
            meta: {
                label: 'Articles',
                auth: true,
                permission: 'article:view',
            },
        },
        {
            path: 'create',
            name: ArticleRouteName.Create,
            component: () => import('@/views/article/Create.vue'),
            meta: {
                label: 'Create Article',
                auth: true,
                permission: 'article:create',
            },
        },
        {
            path: `:${articleParamKey}/edit`,
            name: ArticleRouteName.Edit,
            component: () => import('@/views/article/Create.vue'),
            meta: {
                label: 'Edit Article',
                auth: true,
                permission: 'article:update',
            },
        },
        {
            path: 'templates',
            name: ArticleRouteName.TempIndex,
            component: () => import('@/views/article/Index.vue'),
            meta: {
                label: 'Article Templates',
                auth: true,
                permission: 'manage-articles',
            },
        },
        {
            path: 'templates/create',
            name: ArticleRouteName.TempCreate,
            component: () => import('@/views/article/Index.vue'),
            meta: {
                label: 'Create Article Templates',
                auth: true,
                permission: 'manage-articles',
            },
        },
        {
            path: 'templates/:articleTemplateId/edit',
            name: ArticleRouteName.TempEdit,
            component: () => import('@/views/article/Index.vue'),
            meta: {
                label: 'Edit Article Template',
                auth: true,
                permission: 'manage-articles',
            },
        },
        {
            path: `:${articleParamKey}/details`,
            name: ArticleRouteName.Show,
            component: () => import('./Show.vue'),
            meta: {
                label: 'Show Article',
                auth: true,
                permission: 'article:view',
            },
        },
    ],
}
